/**
 * The SweetTree loading mark — leaves start grey and take their colour in
 * turn, so a wait reads as PROGRESS (Ed's 2026-08-01 design).
 *
 * ☠️ Geometry, colours and the 2.6s cycle are VERBATIM from the
 * app.circleofsupport/web/index.html boot SVG (also ported to both Flutter
 * apps' SweetTreeLoader) — keep every copy identical; see /brand/README.md.
 *
 * This module is the planner's ONE copy. It was previously duplicated across
 * the clients list and the Connect timeline, which double-counted the artwork
 * hexes and failed the brand ratchet on the 2026-09-10 prod deploy. The
 * FILENAME is load-bearing: brand/tools/inventory.py excludes
 * `sweettree_loader` files as artwork-not-UI-palette, mirroring the Flutter
 * apps' sweettree_loader.dart.
 *
 * The leaves carry the shared `stc-leaf` class; index.html.template owns the
 * single keyframes/fill block for it. Callers style size/placement via the
 * class passed in (`tree-loader-mark`, `mark`, …).
 */
export function sweetTreeMarkSvg(markClass: string): string {
  return `<svg class="${markClass}" viewBox="0 0 120 120" aria-hidden="true">
      <path d="M57 118 C57 96 55 84 48 74 M60 118 C60 92 61 78 66 66 M60 100 C60 92 66 86 73 82"
            fill="none" stroke="#8A6A4F" stroke-width="4.5" stroke-linecap="round"/>
      <circle class="stc-leaf" cx="60" cy="20" r="10" style="--c:#E4572E; animation-delay:0s"/>
      <circle class="stc-leaf" cx="38" cy="30" r="9"  style="--c:#F49F0A; animation-delay:.24s"/>
      <circle class="stc-leaf" cx="82" cy="30" r="9"  style="--c:#F7C948; animation-delay:.48s"/>
      <circle class="stc-leaf" cx="26" cy="50" r="9.5" style="--c:#7FB800; animation-delay:.72s"/>
      <circle class="stc-leaf" cx="94" cy="50" r="9.5" style="--c:#2E9E4F; animation-delay:.96s"/>
      <circle class="stc-leaf" cx="44" cy="48" r="11" style="--c:#00A6A6; animation-delay:1.2s"/>
      <circle class="stc-leaf" cx="76" cy="48" r="11" style="--c:#2563EB; animation-delay:1.44s"/>
      <circle class="stc-leaf" cx="60" cy="40" r="12" style="--c:#7B4FBF; animation-delay:1.68s"/>
      <circle class="stc-leaf" cx="36" cy="66" r="8.5" style="--c:#C9268F; animation-delay:1.92s"/>
      <circle class="stc-leaf" cx="84" cy="66" r="8.5" style="--c:#9D0A6D; animation-delay:2.16s"/>
    </svg>`;
}
